import * as React from 'react';
import * as styles from './TourThumbnails.css';

export const TourThumbnails = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles['tour']}>{children}</div>;
};

TourThumbnails.displayName = 'TourThumbnails';
